// PrivacyPolicy.js

import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p>Last Updated: [12-01-2024]</p>

      {/* Add the rest of your privacy policy content here */}

      {/* You can use HTML tags to structure the content */}
      <p>
        Welcome to KRS Party App, a platform created to engage and connect with
        our supporters. 
        This Privacy Policy is designed to help you understand
        how we collect, use, disclose, and safeguard your personal information.

        1. Information We Collect :

        1.1 Personal Information When you register as
        a member or make a donation, we collect information such as your name,
        email address, and payment details. 
        1.2 Usage Data We may collect
        information on how you interact with the app, including pages visited,
        features used, and time spent on the app. 
        1.3 Device Information We may
        collect information about your device, including device type, operating
        system, and browser. 
        
        2. How We Use Your Information Membership
        Processing: We use your information to process and manage your party
        membership. Donations: Your payment information is used to process
        donations and maintain financial records. App Improvement: We analyze
        usage data to enhance and optimize the app's functionality and user
        experience. 
        
        3. Data Sharing Third-Party Services: We may use third-party
        services for payment processing and analytics. These services have their
        own privacy policies. 
        
        4. Security We employ industry-standard security
        measures to protect your personal information. 
        
        5. Your Choices You can
        update your account information and communication preferences in the app
        settings. 
        
        6. Cookies We use cookies to enhance your experience. You can
        control cookie preferences through your browser settings. 
        
        7. Children's
        Privacy Our app is not directed at individuals under the age of 13. We
        do not knowingly collect personal information from children. 
        
        8. Changes
        to Privacy Policy We reserve the right to update our Privacy Policy. Any
        changes will be effective upon posting the updated policy on this page.

        9. Contact Us If you have questions or concerns about our Privacy
        Policy, please contact us at contact.krsparty@gmail.com. 
        
        By using our app, you agree to the terms outlined in this Privacy Policy.
      </p>

      {/* Add your privacy policy sections here */}
    </div>
  );
};

export default PrivacyPolicy;
